import * as React from "react";
const SvgPriorityMedium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 3, fill: "inherit" }));
export default SvgPriorityMedium;
